<div class="c-discontinuedInfo">
  <slotcom-navigation-button
    type="close"
    (click)="closeDialog(false)">
  </slotcom-navigation-button>

  <div class="c-discontinuedInfo__background">
    <div class="c-discontinuedInfo__title">
      <span>{{ 'home.lobby.modals.notify-discontinued.title' | translate | uppercase }}</span>
    </div>

    <div
      class="c-discontinuedInfo__gameIcon"
      [ngStyle]="gameIcon"></div>

    <div class="c-discontinuedInfo__subtitles">
      <span
        [innerHTML]="
          'home.lobby.modals.notify-discontinued.message' | translate: { day: date.day, month: date.month }
        "></span>
      <span [innerHTML]="'home.lobby.modals.notify-discontinued.message_2' | translate"></span>
    </div>

    @if (canPurchase) {
      <slotcom-button
        class="c-button--pink"
        (safeClick)="closeDialog(true)"
        audioType="functionality">
        {{ 'home.details.unlock' | translate | uppercase }}
      </slotcom-button>
    } @else {
      <slotcom-button
        class="c-button--pink"
        (safeClick)="closeDialog(false)"
        audioType="functionality">
        {{ 'home.buttons.accept' | translate | uppercase }}
      </slotcom-button>
    }
  </div>
</div>
